/**
 * @generated SignedSource<<007f227065feb8048066a4dfa46555e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductsSidebar_NavSectionsFragment$data = {
  readonly id: string;
  readonly productsNavSections: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"NavSectionFragment">;
      };
    }>;
  };
  readonly " $fragmentType": "ProductsSidebar_NavSectionsFragment";
};
export type ProductsSidebar_NavSectionsFragment$key = {
  readonly " $data"?: ProductsSidebar_NavSectionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductsSidebar_NavSectionsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "productsNavSections"
        ]
      }
    ]
  },
  "name": "ProductsSidebar_NavSectionsFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "productsNavSections",
      "args": [
        {
          "kind": "Literal",
          "name": "kind",
          "value": "products"
        }
      ],
      "concreteType": "NavSectionNodeConnection",
      "kind": "LinkedField",
      "name": "__ProductsSidebar__productsNavSections_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NavSectionNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NavSection",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NavSectionFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfoObjectType",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": "__ProductsSidebar__productsNavSections_connection(kind:\"products\")"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "a5a084b845ea965992749e75310b7b56";

export default node;
